module.exports = "/build/web/svg/sponsor/wensink.e1346e7b72ce9cd5b1c95a8e4d475137.svg";


//////////////////
// WEBPACK FOOTER
// ./svg/sponsor/wensink.svg
// module id = 226
// module chunks = 24